// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArtifactModalController from "./artifact_modal_controller"
application.register("artifact-modal", ArtifactModalController)

import FontAwesomeSelectController from "./font_awesome_select_controller"
application.register("font-awesome-select", FontAwesomeSelectController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import ShowHideController from "./show_hide_controller"
application.register("show-hide", ShowHideController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)
